import * as React from 'react';

import { IconButton } from '~shared/components/buttons';
import { IconCheckmark, IconTrash } from '~shared/components/icons/standard';

import { FileDropFileWrapper } from './FileDropFileWrapper';

interface FileDropSuccessProps {
  uploadType: 'multiple' | 'single';
  fileName: string;
  handleRemove: () => void;
  multiple?: boolean;
}

export function FileDropSuccess({
  multiple = false,
  fileName,
  handleRemove,
}: FileDropSuccessProps) {
  return (
    <FileDropFileWrapper
      fileName={
        <FileDropFileWrapper.FileName>
          {multiple ? (
            <IconCheckmark
              title="Success"
              className="text-green-700"
              titleId="file-drop-success"
            />
          ) : null}
          <FileDropFileWrapper.TruncatedFileName
            fileName={fileName}
            className="text-sm font-medium leading-8"
          />
        </FileDropFileWrapper.FileName>
      }
      actions={
        <IconButton appearance="ghost" onClick={handleRemove}>
          <IconTrash
            title="Remove"
            titleId="file-drop-remove"
            className="text-red-800"
          />
        </IconButton>
      }
    />
  );
}
